import { ValueFormatterParams } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import React, { useCallback, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import IdentifyVehicleIcon from "../../../../assets/images/identifyVehicleIcon.svg";
import Grid from "../../../../components/Grid";
import CustomStatusFilter from "../../../../components/Grid/components/CustomStatusFilter";
import Status from "../../../../components/Grid/components/Status";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import {
  formatDateTimeBR,
} from "../../../../helpers/format";
import { useModal } from "../../../../hooks/ModalContext";
import { useAuth } from "../../../../hooks/AuthenticateContext";
import api from "../../../../services/api";
import Create from "./Create";
import Info from "./Info";
import { IOperacoesPortoCarrossel } from "./types/types";
import CarrosselVeiculos from "./components/CarrosselVeiculos";
import Can from "../../../../components/Can";

const STATUS_OPERACOES_PORTO_CARROSSEL = [
  { id: 0, label: "Ativo", color: "#008000", icon: "#008000" },
  { id: 3, label: "Finalizado", color: "#C0C0C0", icon: "#C0C0C0" },
];

const OperacoesPortoCarrossel: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "status",
      headerName: "Status",
      cellRenderer: (params: CustomCellRendererProps) => {
        if (params.data) {
          console.log(`status cell renderer params ${params.data.id_operacao_porto_carrossel}`, params.data.status);
          return (
            <Status
              data={STATUS_OPERACOES_PORTO_CARROSSEL}
              status={params.data.status}
            />
          );
        }
      },
      filter: CustomStatusFilter,
      filterParams: { status: STATUS_OPERACOES_PORTO_CARROSSEL },
    },
    {
      field: "operacao_porto_carrossel_transportadora.transportadora.razao_social",
      headerName: "Transportadora",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "proprietarioDeCarga.razao_social",
      headerName: "Proprietário de Carga",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "terminal.razao_social",
      headerName: "Terminal",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_inicio_operacao",
      headerName: "Data Início",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      },
    },
    {
      field: "data_fim_operacao",
      headerName: "Data Fim",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      },
    },
    {
      field: "urgencia",
      headerName: "Urgência",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ? "Sim" : "Não";
      },
    },
    {
      field: "intervalo_acesso_liberado_porto",
      headerName: "Intervalo Acesso",
      filter: true,
    },
    {
      field: "valor_tonelada",
      headerName: "Valor Tonelada",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return `R$ ${params.value}`;
        }
        return "---";
      },
    },
    {
      field: "tonelada_prevista_transportadas",
      headerName: "Tonelada Prevista",
      filter: true,
    },
    {
      field: "toneladas_transportadas",
      headerName: "Toneladas Transportadas",
      filter: true,
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data Modificação",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      },
    },
  ]);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<IOperacoesPortoCarrossel>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [showCarrosselVeiculos, setShowCarrosselVeiculos] = useState<boolean>(false);
  const [idOperacaoPortoCarrosselTransportadora, setIdOperacaoPortoCarrosselTransportadora] = useState<number>();

  const { isModalOpen, openModal, closeModal } = useModal();
  const { user } = useAuth();

  const gridRef = useRef<any>();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_operacao_porto_carrossel: rowId,
        id_usuario_historico: user?.id,
      };

      await api.post("/deletar/operacaoPortoCarrossel", body);

      setLoading(false);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
      <Loading loading={loading} />
      {isModalOpen && (
        <Create
          isEdit={isEdit}
          isView={isView}
          selectedRow={selectedRow}
          onClear={() => closeModal()}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      {showCarrosselVeiculos && (
        <CarrosselVeiculos
          id_operacao_porto_carrossel_transportadora={idOperacaoPortoCarrosselTransportadora}
          onClear={() => {
            setShowCarrosselVeiculos(false);
          }}
          onConfirm={() => {
            setShowCarrosselVeiculos(false);
          }}
        />
      )}

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_operacao_porto_carrossel)}
          row={selectedRow?.terminal?.razao_social || ""}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Operação Porto Carrossel"
          onClose={() => setIsView(!isView)}
        />
      )}

      <div className="flex items-center justify-between w-full mb-3">
        <div>
          <h1 className="text-2xl text-[#000000] font-bold">Operações Porto Carrossel</h1>
        </div>
        <div className="mr-14">
          <Can acao="SALVAR">
          <button
            className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
            onClick={() => openModal()}
            id="btnCreate"
          >
            Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
          </button>
          </Can>
        </div>
      </div>
      <div className="flex w-full">
        <Grid
          ref={gridRef}
          columns={columns}
          filters={[]}
          pagination
          path="/listar/operacaoPortoCarrossel"
          status={STATUS_OPERACOES_PORTO_CARROSSEL}
          onView={(data: any) => {
            setSelectedRow(data);
            setIsView(!isView);
          }}
          onDelete={(data: any) => {
            setIsRemove(!isRemove);
            setSelectedRow(data);
          }}
          onUpdate={(data: any) => {
            setSelectedRow(data);
            setIsEdit(!isEdit);
            openModal();
          }}
          customButtons={[
            {
              label: "Veiculos do Carrossel",
              action: (data: any) => {
                // Acessando o ID conforme instrução do usuário, ajustando caso a estrutura seja ligeiramente diferente
                const id = data.operacao_porto_carrossel_transportadora?.transportadora?.id_operacao_porto_carrossel_transportadora 
                        || data.operacao_porto_carrossel_transportadora?.id_operacao_porto_carrossel_transportadora;
                
                if (id) {
                  setIdOperacaoPortoCarrosselTransportadora(id);
                  setShowCarrosselVeiculos(true);
                } else {
                   console.warn("ID operacao_porto_carrossel_transportadora não encontrado", data);
                }
              },
              status: [0, 3],
              icon: () => {
                return IdentifyVehicleIcon;
              },
            },
          ]}
        />
      </div>
    </div>
  );
};

export default OperacoesPortoCarrossel;

